import "./WeekdayStatusCell.scss"

import PropTypes from "prop-types"
import React from "react"

import { EMAIL_SCHEDULER_WEEKDAYS } from "../../../constants/email-constants"
import WeekdayStatus from "../WeekdayStatus"

const WeekDayStatusCell = ({ intervals, setTooltip, closeTooltip, tt }) => {
  return (
    <div className="week">
      {EMAIL_SCHEDULER_WEEKDAYS.map(weekDay => {
        const dayInterval = intervals?.filter(scheduledDay => scheduledDay.day === weekDay.day)

        return (
          <WeekdayStatus
            key={weekDay.key}
            intervals={dayInterval}
            weekDay={weekDay}
            setTooltip={setTooltip}
            closeTooltip={closeTooltip}
            tt={tt}
          />
        )
      })}
    </div>
  )
}

WeekDayStatusCell.propTypes = {
  intervals: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.string,
      startTime: PropTypes.string,
      endTime: PropTypes.string,
    }),
  ),
  setTooltip: PropTypes.func,
  closeTooltip: PropTypes.func,
}

WeekDayStatusCell.defaultProps = {
  intervals: [],
  setTooltip: () => {},
  closeTooltip: () => {},
}

export default WeekDayStatusCell
